import React from 'react'
import { Button } from 'shared/components'
import styles from './ChallengeOverview.module.scss'

type ComingSoonButtonProps = {
  onClick: () => void
}

const ComingSoonButton = ({ onClick }: ComingSoonButtonProps) => {
  const text = `Coming Soon! Schedule your challenge now!`
  return <Button containerStyle={`${styles.selectPlanBtn} bg-coral mb-4 lg:max-w-lg w-full md:w-[70%] mx-auto `} onClick={onClick} label={text} />
}

export { ComingSoonButton }
